import { useEffect, useState } from 'react'
import { Logo } from './Logo'
import { SmoothAnchor } from './SmoothAnchor'

const LINKS = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Processo', href: '#processo' },
  { label: 'Método', href: '#metodo' },
  { label: 'Contato', href: '#contato' },
]

export function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-space-950/70 backdrop-blur-xl border-b border-orb-500/15' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <SmoothAnchor href="#top" className="shrink-0">
          <Logo />
        </SmoothAnchor>

        <ul className="hidden items-center gap-8 lg:flex">
          {LINKS.map((link) => (
            <li key={link.href}>
              <SmoothAnchor
                href={link.href}
                className="text-sm font-medium text-white/70 transition-colors hover:text-white"
              >
                {link.label}
              </SmoothAnchor>
            </li>
          ))}
        </ul>

        <SmoothAnchor
          href="#contato"
          className="hidden rounded-full border border-orb-300/50 bg-gradient-to-r from-orb-500 to-orb-700 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_0_0_1px_rgba(200,160,255,0.35),0_0_25px_-6px_rgba(139,60,240,0.9)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_0_1px_rgba(216,190,255,0.7),0_0_32px_-4px_rgba(168,116,255,1)] lg:inline-block"
        >
          Fale com a gente
        </SmoothAnchor>

        <button
          aria-label="Abrir menu"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white lg:hidden"
        >
          <span className="relative block h-3.5 w-4">
            <span
              className={`absolute left-0 top-0 h-[1.5px] w-full bg-white transition-transform ${open ? 'translate-y-[6.5px] rotate-45' : ''}`}
            />
            <span
              className={`absolute left-0 top-1/2 h-[1.5px] w-full -translate-y-1/2 bg-white transition-opacity ${open ? 'opacity-0' : ''}`}
            />
            <span
              className={`absolute bottom-0 left-0 h-[1.5px] w-full bg-white transition-transform ${open ? '-translate-y-[6.5px] -rotate-45' : ''}`}
            />
          </span>
        </button>
      </nav>

      <div
        className={`overflow-hidden transition-[max-height] duration-400 ease-out lg:hidden ${open ? 'max-h-96' : 'max-h-0'}`}
      >
        <ul className="flex flex-col gap-1 border-t border-white/10 bg-space-950/95 px-5 pb-5 pt-3 backdrop-blur-xl">
          {LINKS.map((link) => (
            <li key={link.href}>
              <SmoothAnchor
                href={link.href}
                onClick={() => setOpen(false)}
                className="block rounded-lg px-3 py-3 text-base font-medium text-white/80 active:bg-white/5"
              >
                {link.label}
              </SmoothAnchor>
            </li>
          ))}
          <li>
            <SmoothAnchor
              href="#contato"
              onClick={() => setOpen(false)}
              className="mt-2 block rounded-full border border-orb-300/50 bg-gradient-to-r from-orb-500 to-orb-700 px-4 py-3 text-center text-sm font-semibold text-white shadow-[0_0_0_1px_rgba(200,160,255,0.35),0_0_25px_-6px_rgba(139,60,240,0.9)]"
            >
              Fale com a gente
            </SmoothAnchor>
          </li>
        </ul>
      </div>
    </header>
  )
}
